import cn from 'classnames'
import Link, { LinkProps } from 'next/link'
import React, { ReactNode } from 'react'
import { CSSProperties } from 'react'
interface Props extends LinkProps {
  className?: string
  children: ReactNode
  target?: string
  rel?: string
  onMouseOver?: () => void
  style?: CSSProperties
  title?: string
  tabIndex?: number
  parentGridCols?: number
  childGridCols?: number
}

export const CompatibleLink: React.FC<Props> = ({
  className,
  children,
  href,
  as,
  replace,
  scroll,
  shallow,
  passHref,
  locale,
  onMouseEnter,
  onTouchStart,
  onClick,
  target,
  rel,
  onMouseOver,
  style,
  title,
  tabIndex,
  parentGridCols = 0,
  childGridCols = 0,
}) => {
  return href ? (
    <Link
      prefetch={false}
      href={href}
      as={as}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      passHref={passHref}
      locale={locale}
      onMouseEnter={onMouseEnter}
      onTouchStart={onTouchStart}
      target={target}
      rel={rel}
      onMouseOver={onMouseOver}
      onClick={onClick}
      style={style}
      title={title}
      tabIndex={tabIndex}
    >
      <span className={cn(className)}>{children}</span>
    </Link>
  ) : (
    <>
      {parentGridCols > 0 && childGridCols > 0 ? (
        <>{children}</>
      ) : (
        <div>
          <span onClick={onClick} className={cn(className)} style={style} title={title}>
            {children}
          </span>
        </div>
      )}
    </>
  )
}
